/**
 * Footer Component JavaScript
 *
 * Handles footer interactions including newsletter signup
 */

// Newsletter form functionality
function initNewsletterForm() {
    const newsletterForms = document.querySelectorAll('.newsletter-form');
    
    newsletterForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const emailInput = form.querySelector('.newsletter-form__input');
            const submitButton = form.querySelector('.newsletter-form__submit');
            const email = emailInput.value.trim();
            
            // Basic email validation
            if (!isValidEmail(email)) {
                showFormMessage(form, 'Please enter a valid email address.', 'error');
                return;
            }
            
            // Disable form during submission
            submitButton.disabled = true;
            submitButton.style.opacity = '0.6';
            
            // Here you would typically send the email to your newsletter service
            // For now, we'll simulate a successful submission
            setTimeout(() => {
                showFormMessage(form, 'Thank you for subscribing!', 'success');
                emailInput.value = '';
                submitButton.disabled = false;
                submitButton.style.opacity = '';
            }, 1000);
        });
    });
}

// Email validation helper
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// Show form message helper
function showFormMessage(form, message, type) {
    // Remove any existing message
    const existingMessage = form.querySelector('.newsletter-form__message');
    if (existingMessage) {
        existingMessage.remove();
    }
    
    // Create new message element
    const messageEl = document.createElement('div');
    messageEl.className = `newsletter-form__message newsletter-form__message--${type}`;
    messageEl.textContent = message;
    messageEl.style.cssText = `
        margin-top: 0.5rem;
        padding: 0.5rem;
        border-radius: 4px;
        font-size: 0.875rem;
        ${type === 'error' ? 'color: #dc2626; background-color: rgba(220, 38, 38, 0.1);' : 'color: #059669; background-color: rgba(5, 150, 105, 0.1);'}
    `;
    
    // Insert message after form
    form.parentNode.insertBefore(messageEl, form.nextSibling);
    
    // Remove message after 5 seconds
    setTimeout(() => {
        if (messageEl.parentNode) {
            messageEl.remove();
        }
    }, 5000);
}

// Smooth scroll for footer links (if needed)
function initFooterSmoothScroll() {
    const footerLinks = document.querySelectorAll('.site-footer a[href^="#"]');
    
    footerLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            const target = document.querySelector(href);
            
            if (target) {
                e.preventDefault();
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

// Initialize footer functionality
function initFooter() {
    initNewsletterForm();
    initFooterSmoothScroll();
    
    console.log('✅ Footer component initialized');
}

// Export for use in theme.js
export { initFooter };

// Auto-initialize if DOM is already loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter);
} else {
    initFooter();
}